import { useEffect } from "react";

/**
 * A short-lived confirmation in the corner. `toast` is { message, type } or null;
 * it dismisses itself after a few seconds, or on click.
 */
export default function Toast({ toast, onClose, duration = 4000 }) {
  useEffect(() => {
    if (!toast) return undefined;

    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [toast, onClose, duration]);

  if (!toast) return null;

  const success = toast.type !== "error";

  return (
    <div className="fixed bottom-4 end-4 z-[60] max-w-sm">
      <div
        role="status"
        className={`flex items-start gap-3 rounded-lg border px-4 py-3 text-sm shadow-lg ${
          success
            ? "border-accent-line bg-accent-wash text-accent-text"
            : "border-danger-line bg-danger-wash text-danger-text"
        }`}
      >
        <span className="flex-1">{toast.message}</span>
        <button type="button" onClick={onClose} aria-label="Dismiss" className="leading-none">
          ×
        </button>
      </div>
    </div>
  );
}
